const exportConfig = {
    flaggedMetadata: {
        childKeys: ['issues'],
        keyOrder: 'flaggedMetadata',
        parentKeys: [
            'amsPrograms.title',
            'status',
            'lastUpdated',
            'amsPrograms.lastUpdate',
            'amsPrograms.echostarId',
            'amsPrograms[0].tmsId',
            'amsPrograms[0].seriesId',
            'amsPrograms[0].echostarContentType',
            'roviProgramId',
        ],
        priorityKeys: [
            'amsPrograms.title',
            'status',
            'lastUpdated',
            'amsPrograms.lastUpdate',
            'amsPrograms.echostarId',
            'amsPrograms[0].tmsId',
            'amsPrograms[0].seriesId',
            'amsPrograms[0].echostarContentType',
            'roviProgramId',
        ],
        blacklistKeys: ['version'],
        customKeys: [
            {
                formatter: 'amsProgramTitle',
                key: 'amsPrograms.title',
            },
            {
                formatter: 'amsProgramLastUpdate',
                key: 'amsPrograms.lastUpdate',
            },
            {
                formatter: 'amsProgramEchostarId',
                key: 'amsPrograms.echostarId',
            },
            {
                formatter: 'tmsId',
                key: 'amsPrograms[0].tmsId',
            },
            {
                formatter: 'franchiseId',
                key: 'amsPrograms[0].seriesId',
            },
            {
                formatter: 'contentType',
                key: 'amsPrograms[0].echostarContentType',
            },
        ],
    },
    mediaItems: {
        childKeys: ['offerings'],
        keyOrder: 'mediaItems',
        parentKeys: [
            'guid',
            'amsFranchise.echostarId',
            'amsFranchise.roviProgramId',
            'amsFranchise.tmsId',
            'amsEpisode.echostarId',
            'amsEpisode.roviProgramId',
            'amsEpisode.tmsId',
            'provider.name',
            'externalNetwork.name',
            'service.serviceName',
        ],
        priorityKeys: [
            'guid',
            'amsFranchise.echostarId',
            'amsFranchise.roviProgramId',
            'amsFranchise.tmsId',
            'amsEpisode.echostarId',
            'amsEpisode.roviProgramId',
            'amsEpisode.tmsId',
            'provider.name',
            'externalNetwork.name',
            'service.serviceName',
        ],
    },
    moviesAndPrograms: {
        keyOrder: 'moviesAndPrograms',
        priorityKeys: ['echostarId', 'roviProgramId', 'mappedCounts.DISH', 'mappedCounts.SLING'],
    },
    investigations: {
        parentKeys: ['amsFranchise.tmsId', 'amsEpisode.tmsId'],
        priorityKeys: ['amsFranchise.tmsId', 'amsEpisode.tmsId'],
    },
    networks: {
        keyOrder: 'networks',
    },
    providers: {
        blacklistKeys: ['providerId', 'version'],
    },
    recordLocking: {
        blacklistKeys: ['recordId'],
        customKeys: [
            {
                formatter: 'timestamp',
                key: 'timestamp',
            },
        ],
    },
    rules: {
        priorityKeys: ['ruleId', 'name', 'category', 'status'],
    },
};

export default exportConfig;
